module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Abstract Name Service Snap","short_name":"ANS Snap","description":"Install the ANS MetaMask Snap to resolve .abs names on Abstract.","icon":"static/logo.png","include_favicon":false,"theme_color":"#1cd47e","background_color":"#0b0f10","display":"standalone","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"506e6d454ed1ce3c1c1dfa4bdb2bdb47"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
